import { eventBus } from '../events';
import './HUD.css';

export class HUD {
  private controlsHint: HTMLDivElement;
  private muteBtn: HTMLButtonElement;
  private muted = false;

  constructor(parent: HTMLElement) {
    // Back to site link
    const backLink = document.createElement('div');
    backLink.className = 'hud-back-link';
    backLink.innerHTML = '<a href="/">\u2190 Back to Site</a>';
    parent.appendChild(backLink);

    // Resume download button (top-right, left of mute)
    const resumeBtn = document.createElement('button');
    resumeBtn.className = 'hud-resume-btn';
    resumeBtn.innerHTML = '\uD83D\uDCC4 Resume';
    resumeBtn.title = 'Download resume as PDF';
    resumeBtn.addEventListener('click', () => this.showDownloadConfirm(parent));
    parent.appendChild(resumeBtn);

    // Mute button (top-right)
    this.muteBtn = document.createElement('button');
    this.muteBtn.className = 'hud-mute-btn';
    this.muteBtn.textContent = '\uD83D\uDD0A';
    this.muteBtn.title = 'Toggle music';
    this.muteBtn.addEventListener('click', () => {
      this.muted = !this.muted;
      this.muteBtn.textContent = this.muted ? '\uD83D\uDD07' : '\uD83D\uDD0A';
      eventBus.emit('audio:toggle-mute');
    });
    parent.appendChild(this.muteBtn);

    // Controls hint (desktop only)
    this.controlsHint = document.createElement('div');
    this.controlsHint.className = 'hud-controls-hint';
    this.controlsHint.textContent = 'Arrow Keys / WASD to move \u2022 Space to jump \u2022 E to interact';
    parent.appendChild(this.controlsHint);

    // Hide hint after first movement
    let hintHidden = false;
    eventBus.on('player:move', () => {
      if (!hintHidden) {
        hintHidden = true;
        setTimeout(() => {
          this.controlsHint.classList.add('hidden');
        }, 3000);
      }
    });
  }

  private showDownloadConfirm(parent: HTMLElement): void {
    const backdrop = document.createElement('div');
    backdrop.className = 'hud-confirm-backdrop';

    const dialog = document.createElement('div');
    dialog.className = 'hud-confirm-dialog';
    dialog.innerHTML = '<p>Download resume as PDF?</p>';

    const btnRow = document.createElement('div');
    btnRow.className = 'hud-confirm-buttons';

    const yesBtn = document.createElement('button');
    yesBtn.className = 'hud-confirm-yes';
    yesBtn.textContent = 'Download';
    yesBtn.addEventListener('click', () => {
      const a = document.createElement('a');
      a.href = 'kevin-warnock-resume.pdf';
      a.download = 'kevin-warnock-resume.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      backdrop.remove();
    });

    const noBtn = document.createElement('button');
    noBtn.className = 'hud-confirm-no';
    noBtn.textContent = 'Cancel';
    noBtn.addEventListener('click', () => backdrop.remove());

    btnRow.appendChild(yesBtn);
    btnRow.appendChild(noBtn);
    dialog.appendChild(btnRow);
    backdrop.appendChild(dialog);
    parent.appendChild(backdrop);
  }
}
